import { defineMessages } from "react-intl";

export const messages = defineMessages({
  mainTitle: {
    defaultMessage: "Add Azure Subscription",
    id: "azure-subscription-wizard-messages.mainTitle",
  },

  specifyAccountTitle: {
    defaultMessage: "Specify configuration account",
    id: "azure-subscription-wizard-messages.specifyAccountTitle",
  },

  specifyAccountSubTitle: {
    defaultMessage:
      "This account will be used only in the configuration process and will not be preserved.",
    id: "azure-subscription-wizard-messages.specifyAccountSubTitle",
  },

  specifyAccountInfoTitle: {
    defaultMessage: "Account requirements:",
    id: "azure-subscription-wizard-messages.specifyAccountInfoTitle",
  },

  specifyAccountInfoPoint: {
    defaultMessage: "Account must be a member of the Global Administrator role.",
    id: "azure-subscription-wizard-messages.specifyAccountInfoPoint",
  },

  specifyAccountFieldLabel: {
    defaultMessage: "Configuration account",
    id: "azure-subscription-wizard-messages.specifyAccountFieldLabel",
  },

  specifyAccountFieldTooltip: {
    defaultMessage:
      "This configuration account is used by Cayosoft Guardianto connect to your Microsoft 365 tenant,retrieve configuration data, and perform operations required for Forest Recovery.",
    id: "azure-subscription-wizard-messages.specifyAccountFieldTooltip",
  },

  specifyAccountFieldPlaceholder: {
    defaultMessage: "Enter account name like username@domain.com",
    id: "azure-subscription-wizard-messages.specifyAccountFieldPlaceholder",
  },

  createApplicationTitle: {
    defaultMessage: "Create new application",
    id: "azure-subscription-wizard-messages.createApplicationTitle",
  },

  createApplicationInfo: {
    defaultMessage:
      "Sign in to your Microsoft Entra tenant using a Global Administrator account so Cayosoft Guardian can automatically create and configure the Microsoft Entra application and assign the required roles.",
    id: "azure-subscription-wizard-messages.createApplicationInfo",
  },

  createApplicationSignInLabel: {
    defaultMessage: "Sign in to your tenant using configuration account",
    id: "azure-subscription-wizard-messages.createApplicationSignInLabel",
  },

  accountField: {
    defaultMessage: "Name of Entra application",
    id: "azure-subscription-wizard-messages.accountField",
  },

  accountFieldTooltip: {
    defaultMessage:
      "Specify a display name for the Microsoft Entra application that Cayosoft Guardian will automatically create and configure.",
    id: "azure-subscription-wizard-messages.accountFieldTooltip",
  },

  selectAzureResourceTitle: {
    defaultMessage: "Select Azure resource subscription",
    id: "azure-subscription-wizard-messages.selectAzureResourceTitle",
  },

  selectAzureResourceSubTitle: {
    defaultMessage:
      "Select the Azure subscription that Cayosoft Guardian will use for recovery resources.",
    id: "azure-subscription-wizard-messages.selectAzureResourceSubTitle",
  },

  selectAzureResourceInfo: {
    defaultMessage:
      "The provided  Azure subscription will be used to create and manage cloud resources required by Cayosoft Guardian. Azure usage may incur additional costs. {link}.",
    id: "azure-subscription-wizard-messages.selectAzureResourceInfo",
  },

  selectAzureResourceField: {
    defaultMessage: "Select subscription",
    id: "azure-subscription-wizard-messages.selectAzureResourceField",
  },

  loadingSubscriptions: {
    defaultMessage: "Loading subscriptions...",
    id: "azure-subscription-wizard-messages.loading-subscriptions",
  },

  addedSubscriptionTitle: {
    defaultMessage: "Added",
    id: "azure-subscription-wizard-messages.addedSubscription",
  },

  addedSubscriptionStep: {
    defaultMessage: "Manage subscription",
    id: "azure-subscription-wizard-messages.addedSubscriptionStep",
  },

  addedSubscriptionSubTitle: {
    defaultMessage: "Review the subscription details and complete the configuration.",
    id: "azure-subscription-wizard-messages.addedSubscriptionSubTitle",
  },

  createApplicationSignIn: {
    defaultMessage: "Sign In",
    id: "azure-subscription-wizard-messages.createApplicationSignIn",
  },

  principalAccountError: {
    defaultMessage: "Account name must be less than or equal to 120 characters.",
    id: "azure-subscription-wizard-messages.principalAccountError",
  },

  unknown: {
    defaultMessage: "Unknown",
    id: "azure-subscription-wizard-messages.consent.unknown",
  },

  invalidCredentials: {
    defaultMessage: "Invalid credentials",
    id: "azure-subscription-wizard-messages.invalidCredentials",
  },

  closeConfirmation: {
    defaultMessage: "Azure registration is incomplete.",
    id: "azure-subscription-wizard-messages.close-confirmation",
  },

  learnMore: {
    defaultMessage: "Learn more",
    id: "azure-subscription-wizard-messages.LearnMore",
  },

  selectFlowTitle: {
    defaultMessage: "Select application option",
    id: "azure-subscription-wizard-messages.selectFlow.title",
  },

  selectFlowSubTitle: {
    defaultMessage: "Choose how you want to register the Azure subscription in Cayosoft Guardian.",
    id: "azure-subscription-wizard-messages.selectFlow.subTitle",
  },

  selectFlowLabel: {
    defaultMessage: "Application option",
    id: "azure-subscription-wizard-messages.selectFlow.label",
  },

  flowOptionDefault: {
    defaultMessage: "Create a new application",
    id: "azure-subscription-wizard-messages.selectFlow.option.default",
  },

  flowOptionDefaultDescription: {
    defaultMessage:
      "Use this option to let Cayosoft Guardian create the required Microsoft Entra application automatically.",
    id: "azure-subscription-wizard-messages.selectFlow.option.default.description",
  },

  flowOptionAppCert: {
    defaultMessage: "Use an existing application",
    id: "azure-subscription-wizard-messages.selectFlow.option.appCert",
  },

  flowOptionAppCertDescription: {
    defaultMessage:
      "Use this option to register the Azure subscription with an existing Microsoft Entra application and certificate.",
    id: "azure-subscription-wizard-messages.selectFlow.option.appCert.description",
  },

  appCertFormTitle: {
    defaultMessage: "Application and certificate details",
    id: "azure-subscription-wizard-messages.appCertForm.title",
  },

  appCertFormStepName: {
    defaultMessage: "Enter application and certificate details",
    id: "azure-subscription-wizard-messages.appCertForm.stepName",
  },

  appCertFormSubTitle: {
    defaultMessage:
      "Enter the details of the Microsoft Entra application that Cayosoft Guardian will use to access the Azure subscription.",
    id: "azure-subscription-wizard-messages.appCertForm.subTitle",
  },

  applicationIdLabel: {
    defaultMessage: "Application ID",
    id: "azure-subscription-wizard-messages.appCertForm.applicationId",
  },

  tenantIdLabel: {
    defaultMessage: "Tenant ID",
    id: "azure-subscription-wizard-messages.appCertForm.tenantId",
  },

  certificateLabel: {
    defaultMessage: "Certificate",
    id: "azure-subscription-wizard-messages.appCertForm.certificate",
  },

  uploadCertificateButton: {
    defaultMessage: "Upload certificate",
    id: "azure-subscription-wizard-messages.appCertForm.uploadButton",
  },

  certificateHelperText: {
    defaultMessage:
      "Upload a certificate file that includes the private key, such as a .pfx or .p12 file. If the certificate is password-protected, enter the password below.",
    id: "azure-subscription-wizard-messages.appCertForm.certificateHelperText",
  },

  certificatePasswordLabel: {
    defaultMessage: "Certificate password",
    id: "azure-subscription-wizard-messages.appCertForm.password",
  },

  certificatePasswordPlaceholder: {
    defaultMessage: "Enter certificate password",
    id: "azure-subscription-wizard-messages.appCertForm.passwordPlaceholder",
  },

  certificateInvalidError: {
    defaultMessage: "Failed to read the certificate file. Please select a valid file.",
    id: "azure-subscription-wizard-messages.appCertForm.certificateInvalidError",
  },
});
